import { UiLanguage } from "./i18n";

export const formatFullDateForUiLanguage = (value: string, language: UiLanguage) => {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }
  return new Intl.DateTimeFormat(language, { dateStyle: "full", timeStyle: "short" }).format(parsed);
};
